import { render, staticRenderFns } from "./CreateNewTeamNotReady.vue?vue&type=template&id=1f9dcd74&scoped=true&"
import script from "./CreateNewTeamNotReady.vue?vue&type=script&lang=js&"
export * from "./CreateNewTeamNotReady.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9dcd74",
  null
  
)

export default component.exports